<template>
  <div>
    <div class="has-background-white" style="padding: 0.5em;">
      <div style="text-align: right;">
        <b-tooltip label="ランダムランキングを追加しました"
            position="is-left" always :active="tooltipActive">
          <b-icon icon="random" style="margin-left:1em;"
                  @click.native="$router.push('/randomranking')">
          </b-icon>
        </b-tooltip>
        <b-icon icon="share-alt" style="margin-left:1em;"
                @click.native="twitterShare()">
        </b-icon>
      </div>
      <div class="list-header">
        <p class="is-size-4 has-text-grey-dark">
          デイリーランキング
        </p>
        <input class="input" type="date" v-model="inputDate" v-on:change="moveOtherDateRanking">
        <div style="margin-top:1em;">
          <b-pagination
            :total="ranking_tweets.length"
            :current.sync="current_page_num"
            :range-before="2"
            :range-after="1"
            :order="'is-centered'"
            :size="''"
            :rounded="true"
            :per-page="one_page_tweet_num"
            :icon-prev="'chevron-left'"
            :icon-next="'chevron-right'"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            type="is-danger">
          </b-pagination>
        </div>
      </div>
    </div>
    <div  class="columns is-gapless is-multiline is-desktop">
      <div v-for="tweet in show_tweets" :key="tweet.id" class="column is-4-desktop">
        <TweetBox :tweet_info="tweet" @tweet-regist="changeRegistState(tweet.id)"/>
      </div>
    </div>
    <b-pagination
        class="list-header"
        :total="ranking_tweets.length"
        :current.sync="current_page_num"
        :range-before="2"
        :range-after="1"
        :order="'is-centered'"
        :size="''"
        :rounded="true"
        :per-page="one_page_tweet_num"
        :icon-prev="'chevron-left'"
        :icon-next="'chevron-right'"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        type="is-danger">
    </b-pagination>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import firebase from '@/firebase'
import TweetBox from '@/components/TweetBox.vue'

export default {
  title: "- デイリーランキング",
  components: {
    TweetBox
  },
  data() {
    return {
      ranking_tweets: [],
      current_page_num: 1,
      isLoading: false,
      inputDate: "",
      tooltipActive: true,
    }
  },
  computed: {
    day_str() {
      return this.$route.params.day
    },
    page_num() {
      if(this.$route.query.page == undefined){return 1}
      return Number(this.$route.query.page)
    },
    one_page_tweet_num: () => 15,
    show_tweets() {
      if(this.ranking_tweets.length == 0 || this.ranking_tweets.length == undefined){
        return []
      }
      const start_idx = this.one_page_tweet_num*(this.page_num-1)
      const end_idx = start_idx + this.one_page_tweet_num
      return this.ranking_tweets.filter((elm, idx) => start_idx<=idx && idx<end_idx)
    },
  },
  watch:{
    current_page_num(val) {
      this.move_list_page(val)
    },
    day_str() {
      this.loadRankingDataFromStorage()
    }
  },
  created() {
    if(this.page_num != 1){
      this.current_page_num = this.page_num
    }
    setTimeout(function() {
      this.tooltipActive = false
    }.bind(this), 5000)
    this.updateDate()
    if(this.isFutureDay(this.day_str)){
      this.moveOtherDateRanking()
    }
    this.loadRankingDataFromStorage()
  },
  methods: {
    async loadRankingDataFromStorage() {
      if(this.isFutureDay(this.day_str)) return
      let ranking_json = await firebase.getRankingDataFromStorage(this.day_str)
      if(ranking_json.length > 0){
        ranking_json = ranking_json.map((tweet)=>{
          tweet.registeredListname = this.$store.getters.findRegistedList(tweet.id)
          return tweet          
        })
        this.ranking_tweets = ranking_json
      }
      else{
        this.ranking_tweets = []
      }
    },
    move_list_page(move_page) {
      if(this.ranking_tweets.length <= this.one_page_tweet_num*(move_page-1)) return
      window.scrollTo({top: 100})
      this.$router.push({path:`/ranking/${this.day_str}`, query: { page: move_page } }).catch(()=>{})
    },
    twitterShare(){
      const twitter_share_url = 'https://twitter.com/intent/tweet'
      const tweet_content = `${this.day_str}のランキング`
      const current_url_without_query = location.href.split(/[?#]/)[0]
      const hashtag = "Twistock"
      const shareURL = `${twitter_share_url}?text=${tweet_content}&url=${current_url_without_query}&hashtags=${hashtag}`  
      location.href = shareURL
    },
    updateDate() {
      const year = this.day_str.substr(0, 4)
      const month = this.day_str.substr(4, 2)
      const day = this.day_str.substr(6, 2)
      this.inputDate = `${year}-${month}-${day}` 
    },
    isFutureDay(day) {
      const today_str = dayjs().add(-2, 'day').format('YYYYMMDD')
      return (Number(day) > Number(today_str))
    },
    moveOtherDateRanking() {
      let next_page_date = this.inputDate.replace(/-/g, "")
      if(this.isFutureDay(next_page_date)){
        this.inputDate = dayjs().add(-2, 'day').format('YYYY-MM-DD')
        next_page_date = dayjs().add(-2, 'day').format('YYYYMMDD')
      }
      this.current_page_num = 1
      this.$router.push({path:`/ranking/${next_page_date}`}).catch(()=>{})
    },
    changeRegistState(tweet_id) {
      for(let idx in this.ranking_tweets){
        if(this.ranking_tweets[idx].id == tweet_id){
          this.ranking_tweets[idx].registeredListname = this.$store.getters.findRegistedList(tweet_id)
          return
        }
      }
    },
  },
}
</script>

<style>
.list-header {
  max-width: 40em;
  margin: 0 auto;
}
</style>